module.exports = __webpack_public_path__ + "static/GCA-resource-tile-fa547c98ebdc5ad4baf391448d1afb4a.png";